//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalForgotPassword',
  data() {
    return {
      email: null,
      username: null,
      submitting: false,
      error: '',
      isPasswordCompromisedLocal: false
    }
  },
  computed: {
    authenticationStatus() {
      return _.get(this.$store.state, 'auth.authenticationStatus')
    },
    authenticating() {
      return _.get(this.$store.state, 'auth.authenticating')
    }
  },
  methods: {
    beforeOpen (event) {
      this.error = ""
      this.isPasswordCompromisedLocal = event?.params?.is_password_compromised ?? false
      window.dispatchEvent(new Event('resize'));
    },
    close() {
      this.$modal.hide('modal-forgot-password')
    },
    async submit() {
      this.submitting = true
      try {
       let result = await this.$auth().post('/api/common/forgot-password', {
            login: this.username,
            email: this.email,
        })
        let data = _.get(result, 'data')

        if(_.get(data, 'result')) {
          this.$notyf.success(this.$t(_.get(data, 'message')))
          this.username = null
          this.email = null
          this.$modal.hide('modal-forgot-password')
        } else {
          if(_.isObject(_.get(data, 'errors'))) {
            this.error = this.$t(_.get(_.values(_.get(data, 'errors')), '0'))
          } else {
            this.error = this.$t(_.get(data, 'errors'))
          }
          if(!data) {
            this.error = this.$t(_.get(e, 'message'))
          }
        }
      } catch (e) {
        let data = _.get(e, 'response.data')
        if(_.isArray(_.get(data, 'message'))) {
            this.error = this.$t(_.get(data, 'message.0'))
        } else {
          this.error = this.$t(_.get(data, 'message'))
        }
        if(!data) {
          this.error = this.$t(_.get(e, 'message'))
        }
      }
      this.submitting = false
    }
  }
}
